import { useEffect, useState } from "react";
/**
 * Returns the ID of the top-most visible section based on its position in the viewport.
 */
export const useVisibleSectionId = ({ ids, rootMargin = "0px 0px -80% 0px", // Only the top 20% of the viewport is considered "visible"
 }) => {
    const [visibleSectionId, setVisibleSectionId] = useState(null);
    const [ignoreObserver, setIgnoreObserver] = useState(false);
    const suspendObserver = () => {
        setIgnoreObserver(true);
        setTimeout(() => setIgnoreObserver(false), 700); // Temporarily disable the observer to prevent updates during smooth scroll
    };
    useEffect(() => {
        const entriesMap = {};
        const observerCallback = (entries) => {
            if (ignoreObserver)
                return;
            entries.forEach((entry) => {
                const id = entry.target.id;
                if (!id)
                    return;
                entriesMap[id] = entry;
            });
            const visibleEntries = Object.values(entriesMap).filter((entry) => entry.isIntersecting);
            if (visibleEntries.length > 0) {
                // @ts-ignore
                setVisibleSectionId(visibleEntries[0].target.id); // top-most element
            }
        };
        const observer = new IntersectionObserver(observerCallback, {
            rootMargin,
            threshold: 0,
        });
        ids.forEach((id) => {
            const el = document.getElementById(id);
            if (el)
                observer.observe(el);
        });
        return () => {
            observer === null || observer === void 0 ? void 0 : observer.disconnect();
        };
    }, [ids, ignoreObserver, rootMargin]);
    return { visibleSectionId, suspendObserver };
};
